export const GET_GENERAL_ADMIN_SETTINGS = "GET_GENERAL_ADMIN_SETTINGS";
export const PUT_GENERAL_ADMIN_SETTINGS = "PUT_GENERAL_ADMIN_SETTINGS";
export const SET_GENERAL_ADMIN_SETTINGS = "SET_GENERAL_ADMIN_SETTINGS";

export const GET_PUBLIC_GENERAL_SETTINGS = "GET_PUBLIC_GENERAL_SETTINGS";
export const SET_PUBLIC_GENERAL_SETTINGS = "GET_PUBLIC_GENERAL_SETTINGS";